/** DispositionReportCockpit — Cockpit frame for /disposition-report.
 *  Hero strip carries the headline metrics (Close Rate / Sold / No Demo);
 *  the inner DispositionReport supplies the full operational KPI grid + tables.
 */
import { useMemo } from "react";
import { CockpitPage, CockpitMasthead, HeroMetric, HeroDivider } from "@/components/cockpit/CockpitShell";
import { BackToLeadPerformance } from "@/components/BackToLeadPerformance";
import { useAppData } from "@/data/AppDataContext";
import DispositionReport from "./DispositionReport";

export default function DispositionReportCockpit() {
  const { appointmentResults } = useAppData();
  const k = useMemo(() => {
    const total = appointmentResults.length;
    const sold = appointmentResults.filter(r => r.resultType === "sold").length;
    const noDemo = appointmentResults.filter(r => r.resultType === "no_demo").length;
    const closeRate = total - noDemo > 0 ? Math.round((sold / (total - noDemo)) * 100) : 0;
    return { total, sold, noDemo, closeRate };
  }, [appointmentResults]);
  return (
    <CockpitPage>
      <CockpitMasthead
        back={<BackToLeadPerformance />}
        eyebrow="Reporting · Outcomes"
        title="Disposition Report"
        right={
          <>
            <HeroMetric label="Close Rate" value={`${k.closeRate}%`} hero tone={k.closeRate >= 30 ? "good" : "warn"} />
            <HeroDivider />
            <HeroMetric label="Sold" value={k.sold} tone="good" />
            <HeroDivider />
            <HeroMetric label="No Demo" value={k.noDemo} tone="warn" />
          </>
        }
      />
      <DispositionReport embedded />
    </CockpitPage>
  );
}
